import { IDropdownOption } from '@fluentui/react';
import { ChartOptions } from 'chart.js';

export const getAIUnitHourlyMonthDropdownOptions = (firstDateStr: string, lastDateStr: string): IDropdownOption[] => {
  const firstDate = new Date(firstDateStr);
  const lastDate = new Date(lastDateStr);

  const options: IDropdownOption[] = [{ text: 'Entire Period', key: 'entire-period' }];

  const current = new Date(Date.UTC(firstDate.getUTCFullYear(), firstDate.getUTCMonth(), 1));
  const end = new Date(Date.UTC(lastDate.getUTCFullYear(), lastDate.getUTCMonth(), 1));

  while (current <= end) {
    const year = current.getUTCFullYear();
    const month = String(current.getUTCMonth() + 1).padStart(2, '0');

    options.push({
      text: `${year}-${month}`,
      key: `${year}-${month}-01`,
    });

    current.setUTCMonth(current.getUTCMonth() + 1);
  }

  return options;
};

export const getMonthRange = (dateStr: string): { firstDate: string; lastDate: string } => {
  const date = new Date(dateStr);
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();

  const firstDate = new Date(Date.UTC(year, month, 1));
  const lastDate = new Date(Date.UTC(year, month + 1, 0));

  const format = (d: Date) => d.toISOString().slice(0, 10);

  return {
    firstDate: format(firstDate),
    lastDate: format(lastDate),
  };
};

export const lineChartOptions = (title: string, dataLength?: number, titleFontSize?: number): ChartOptions<'line'> => ({
  responsive: true,
  plugins: {
    legend: { position: 'bottom' },
    title: {
      display: title ? true : false,
      text: title,
      font: {
        size: titleFontSize,
        weight: 'bold',
      },
    },
  },
  elements: {
    point: {
      radius: dataLength ? (dataLength <= 1 ? 4 : 2) : 2,
      hoverRadius: 4,
      hitRadius: 10,
    },
  },
  scales: {
    x: {
      ticks: {
        maxTicksLimit: 12,
      },
    },
  },
});

export const aiUnitHourlyComponentsLabelsMap: Record<string, string> = {
  mlopsDeployments: 'MLOps Deployments',
  h2ogpt: 'H2O GPT',
  h2ogptePlayground: 'H2O GPTe Playground',
  mlops: 'MLOps',
  doc_aiProxy: 'DocAI Proxy',
  aiemWorkload: 'AIEM Engines',
  appstore: 'AppStore',
  steam: 'Steam',
  mlApi: 'ML API',
  restScorer: 'eScorer',
  documentAi: 'Document AI',
  notebookWorkload: 'Notebook Workload',
  appstoreApps: 'Appstore Apps',
};

export const aiUnitHourlyComponentsColorMap: Record<string, string> = {
  mlopsDeployments: '#FF8FA3',
  h2ogpt: '#64B5F6',
  h2ogptePlayground: '#FFE082',
  mlops: '#80DEEA',
  doc_aiProxy: '#B39DDB',
  aiemWorkload: '#9FA8DA',
  appstore: '#FFAB91',
  steam: '#90CAF9',
  mlApi: '#F8BBD0',
  restScorer: '#80CBC4',
  documentAi: '#A5D6A7',
  notebookWorkload: '#CE93D8',
  appstoreApps: '#FFCC80',
};
